import React, {useState, useRef} from 'react'
import SocialFasho from '../../assets/Images/fashionBG.svg';
import ProfileFormDropDown from './ProfileFormDropDown';
import userService from '../../services/userapi';
import {getAccessToken} from '../../services/accessToken'
import FastAverageColor from 'fast-average-color';
import { CompactPicker } from 'react-color';

const ProfileUploadItem = ({isOpen, toggle, success}) => {
    const fac = new FastAverageColor();
    
    const itemType = ["Top", "Bottoms", "Footwear"]
    const itemOccasion = ["Casual", "Smart-Casual", "Smart", "Sportswear"]
    
    const [itemTypeSelected, setItemTypeSelected] = useState(itemType[0])
    const [itemOccasionSelected, setitemOccasioneSelected] = useState(itemOccasion[0])
    const [image, setImage] = useState('')
    const [imageHex, setImageHex] = useState("#000")
    const [brand, setBrand] = useState('')
    const [colourPicker,setColourPicker] = useState(false)
    const [readyUpload, setReadyUpload] = useState(false)
    const [error, setError] = useState('')

    let itemStyletypes = new Map()
  
    itemStyletypes.set("Footwear", ["Chelsea Boot", "Brogues", "Boots", "Loafers", "Boat Shoes", "Chukka", "Canvas", "Mules", "Clogs", "Plimsolls", "Heels", "Low Top", "Running Trainers"])
    itemStyletypes.set("Bottoms", ["Skinny Fit Jeans", "Tapered", "Golf Trouser", "Leggings", "Regular Fit Jeans", "Tracksuit", "Leather Jeans", 
                                  "High Waist Jeans", "MOM Jeans", "Skater Jeans", "Drawstring", "Cargo", "Chinos", "Corduroy", "Shorts"])
    itemStyletypes.set("Top", ["Zip Sweaters", "Half Sleeve", "Hoodie", "Polo Collar", "Oxford Shirt", "Overshirt", "Cardigon", "Roll Neck", "Turtle Neck", "Sweatshirt", "Long Sleeve", "Body Suit", 
                              "Crop Top", "Jumper", "Crew Neck", "High Neck", "Tracksuit"])

    const [itemStyleSelected, setitemStyleSelected] = useState(itemStyletypes.get(itemTypeSelected)[0])

    const inputRef = useRef()
    const imageRef = useRef()

    const onInputChange = (e) => {
      setError("")
      setBrand(e.target.value)
    }

    const itemTypeChosen = (value) => {
      setError("")
      setItemTypeSelected(value)

    }
    const itemOccasionChosen = (value) => {
      setError("")
      setitemOccasioneSelected(value)
    }

    const itemStyleChosen = (value) => {
      setError("")
      setitemStyleSelected(value)
    }

    const emptyAllFields = () => {
      setBrand('')
      setImageHex('')
      setImage('')
      setError("")
    }

    const imageOnChange = (e) => {
      const token = getAccessToken()
      setError("")
      // console.log("the wardrobe token", token)
      // console.log("on change image", e.target.files[0])
      
      userService.uploadWardrobeItemImg(token,e.target.files[0]).then(x => {
          console.log("DONE FROM CLIENT", x.data.imagePath)
          setImage(`https://polar-castle-07148.herokuapp.com/api/user/${x.data.imagePath}`)
          // console.log("width", imageRef)
          const imageW = imageRef.current.clientWidth / 2
          const imageH = imageRef.current.clientHeight / 2
          // console.log("the current width", imageW)
          // console.log("the current height", imageH)
          fac.getColorAsync(`https://polar-castle-07148.herokuapp.com/api/user/${x.data.imagePath}`, { width: imageW, left : imageW, }).then(col => {
            console.log("got the colour average", col)
            setImageHex(col.hex)
          }).catch(e => {
            console.log("error calculating colour average", e)
            setError("PLease reupload the image, error due to format of the image !")
            setReadyUpload(false)
          })
      })
      // console.log("on change image", e.target.files[0])
    }

    const colourPickerOnChange = (color, event) => {
      setError("")
      setImageHex(color.hex)
      console.log(color)
    }

    const colourPickerCompleteChange = (color, event) => {
      setColourPicker(!colourPicker)
    }

    const uploadDataToWardrobe = () => {
      const token = getAccessToken()
      console.log("wardrobe has been updated")
      const data = {
        itemType : itemTypeSelected.toUpperCase(),
        itemOccasion : itemOccasionSelected,
        itemUrl : image,
        colour : imageHex,
        brand : brand.toUpperCase(),
        style : itemStyleSelected
      }
      console.log("uploading data with ", data)
      
      if (imageHex != "" && brand != "" && error !="" && image!=""){
          setError("Please Ensure to upload all required details")
          
      }else{
        userService.uploadWardrobeItem(token,data).then(x => {
          console.log("wardrobe item successfully updated", x)
          toggle()
          success(x)
          emptyAllFields()
          
        }).catch(e => {
            console.log("error uploading wardrobe item", e)
            setError("Error Uploading item to your Wardrobe")
            setReadyUpload(false)
        })
      }
      
    }

    return (
        <>
        <div className={`fixed ${isOpen ? "flex" : "hidden"} w-full h-full top-0 b-0 left-0 right-0 cursor-pointer items-start justify-center bg-black z-50 bg-opacity-80 overflow-y-auto`}>
          <div className="sm:max-w-lg w-full p-10 bg-white rounded-xl z-10 sm:mt-14 ">
            <div className="text-center">
              <h2 className="mt-5 text-3xl font-bold text-gray-900 uppercase">
                Upload Item to your wardrobe
              </h2>
              <p className="mt-2 text-sm text-gray-400">Please ensure to center the clothing item in the image.</p>
            </div>
            <div class="mt-8 space-y-3">
              <div className="grid grid-cols-1 space-y-2">
                <label className="text-sm font-bold text-gray-500 tracking-wide">Select Item Type</label>
                <ProfileFormDropDown items={itemType} value={itemTypeSelected} change={itemTypeChosen}/>
                <label className="text-sm font-bold text-gray-500 tracking-wide">Select Items Occasion Type</label>
                <ProfileFormDropDown items={itemOccasion} value={itemOccasionSelected} change={itemOccasionChosen}/>
                <label className="text-sm font-bold text-gray-500 tracking-wide">Select Items Style</label>
                <ProfileFormDropDown items={itemStyletypes.get(itemTypeSelected)} value={itemStyleSelected} change={itemStyleChosen}/>
                <label className="text-sm font-bold text-gray-500 tracking-wide">Brand</label>
                <input class="text-base p-2 border border-gray-300 rounded-lg focus:outline-none focus:border-indigo-500" type="" placeholder="e.g Nike" value={brand} onChange={(e) => onInputChange(e)}/>
              </div>
              <div className="grid grid-cols-1 space-y-2">
                <label className="text-sm font-bold text-gray-500 tracking-wide">Upload Image</label>
                <div className="flex items-center justify-center w-full">
                  <label className="flex flex-col rounded-lg border-4 border-dashed w-full h-60 p-10 group text-center relative">
                    <div className="h-full w-full text-center flex flex-col items-center justify-center">
                      <div className="flex flex-auto max-h-48 w-2/5 mx-auto -mt-10">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-30 w-30" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                        </svg>
                      </div>
                      <p class="pointer-none text-gray-500 "><span class="text-blue-600 hover:underline">select a file</span> from your computer</p>
                    </div>
                    <input ref={inputRef} type="file" className="hidden" accept="image/*" onChange={(evt) => imageOnChange(evt)}/>
                    <img ref={imageRef} className={`${image=='' ? 'hidden' : 'block'} object-cover absolute top-0 left-0 right-0 h-full w-full z-10`} src={image}  />
                  </label>
                </div>
                <div className="self-center">
                  <label className="text-sm font-bold text-gray-500 tracking-wide">Colour</label>
                  <div className="flex flex-row justify-start items-center space-x-5">
                    <div className="h-12 w-12 rounded-xl" style={{backgroundColor : `${imageHex}`}} onClick={() => setColourPicker(!colourPicker)}></div>
                    <CompactPicker 
                      onChange={ colourPickerOnChange}
                      onChangeComplete={ colourPickerCompleteChange } 
                      className={`${colourPicker ? 'block' : 'hidden'}`}
                    />
                    <div className={`${(imageHex!='#000' && !colourPicker) ? 'flex' : 'hidden'} flex-col`}>
                      <label className="text-sm font-bold text-gray-500 tracking-wide">Not the correct color? </label>
                      <label className="text-sm font-bold text-gray-500 tracking-wide">Please select the colour block  </label>
                    </div>
                  </div>
                </div>
                <label className={`${error =='' ? 'hidden' : 'block'} text-sm font-bold text-red-600 tracking-wide`}>{error} </label>
              </div>
              <div className="flex flex-row justify-around space-x-4">
                <button className="my-5 w-1/2 flex justify-center bg-blue-500 text-gray-100 p-4  rounded-full tracking-wide
                    font-semibold  focus:outline-none focus:shadow-outline hover:bg-blue-600 shadow-lg cursor-pointer transition ease-in duration-300" 
                    onClick={() => uploadDataToWardrobe()}
                    disabled={false}
                >
                    Upload
                </button>
                <button type="submit" className="my-5 w-1/2 flex justify-center bg-gray-900 text-gray-100 p-4  rounded-full tracking-wide
                    font-semibold  focus:outline-none focus:shadow-outline hover:bg-blue-600 shadow-lg cursor-pointer transition ease-in duration-300"
                  onClick={() => toggle()}  
                >
                    Cancel
                </button>
              </div>
            </div>
	        </div>
        </div>
      </>
    )
}

export default ProfileUploadItem